const companyNamesCache = {};

// get the names for each company from a list of the sharing for the current job and the current active companies' contact list
export async function GetCompanyNames(contacts, sharing, companyNames = {}, FirebaseWorker) {
  let contactsAndSharing = { ...contacts, ...sharing };
  let promises = [];
  for (let companyId in contactsAndSharing) {
    // Prefer passed-in names, then previously fetched module cache, then firebase
    if (!companyNames[companyId] && companyNamesCache[companyId]) {
      companyNames[companyId] = companyNamesCache[companyId];
    }
    if (!companyNames[companyId]) {
      promises.push(
        FirebaseWorker.ref(`photoheight/companies/${companyId}/name`)
          .once('value')
          .then((s) => {
            let name = s.val();
            if (name) {
              companyNames[companyId] = name;
              companyNamesCache[companyId] = name;
            }
          })
      );
    }
  }
  await Promise.all(promises);
  return companyNames;
}
